import { Link } from 'react-router'
import {
	Card,
	CardContent,
	CardDescription,
	CardFooter,
	CardHeader,
	CardTitle,
} from '#app/components/ui/card'

export default function AboutRoute() {
	return (
		<div className="mx-auto max-w-screen-xl px-4 py-8 lg:py-16">
			<Card className="mb-8">
				<CardHeader>
					<CardTitle className="text-4xl font-bold text-primary">
						About PaideiaTrack
					</CardTitle>
				</CardHeader>

				<CardContent>
					<div className="prose max-w-none">
						<p className="mb-6 text-lg">
							PaideiaTrack is a thoughtfully designed, mobile-first application
							crafted specifically for classical education communities. Rooted
							in the ancient concept of 'paideia'—the formation of moral and
							intellectual excellence—PaideiaTrack supports teachers and
							administrators in fostering student character and maintaining
							classroom discipline.
						</p>

						<h2 className="mb-4 mt-8 text-2xl font-semibold text-primary">
							Our Mission
						</h2>
						<p className="mb-6">
							We equip classical schools with the modern tools needed to nurture
							disciplined, virtuous scholars. By streamlining the process of
							tracking student behavior, teachers and administrators can focus
							on the foundational task of education—guiding students toward
							intellectual growth and moral virtue.
						</p>

						<div className="mt-12 grid gap-8 md:grid-cols-2">
							<Card className="bg-muted">
								<CardHeader>
									<CardTitle className="text-xl font-semibold text-primary">
										For Teachers
									</CardTitle>
								</CardHeader>
								<CardContent>
									<ul className="space-y-2">
										<li className="flex items-start">
											<span className="mr-2">•</span>
											<span>
												Easily track classroom behavior and discipline
											</span>
										</li>
										<li className="flex items-start">
											<span className="mr-2">•</span>
											<span>
												Identify patterns to help guide student development
											</span>
										</li>
										<li className="flex items-start">
											<span className="mr-2">•</span>
											<span>Seamless integration with FACTS SIS</span>
										</li>
										<li className="flex items-start">
											<span className="mr-2">•</span>
											<span>Mobile-first design for classroom flexibility</span>
										</li>
									</ul>
								</CardContent>
							</Card>

							<Card className="bg-muted">
								<CardHeader>
									<CardTitle className="text-xl font-semibold text-primary">
										For Administrators
									</CardTitle>
								</CardHeader>
								<CardContent>
									<ul className="space-y-2">
										<li className="flex items-start">
											<span className="mr-2">•</span>
											<span>Comprehensive reporting across all classrooms</span>
										</li>
										<li className="flex items-start">
											<span className="mr-2">•</span>
											<span>Track school-wide behavioral trends</span>
										</li>
										<li className="flex items-start">
											<span className="mr-2">•</span>
											<span>
												Configure school years and manage student enrollment
											</span>
										</li>
										<li className="flex items-start">
											<span className="mr-2">•</span>
											<span>Control user permissions and system settings</span>
										</li>
									</ul>
								</CardContent>
							</Card>
						</div>

						<h2 className="mb-4 mt-12 text-2xl font-semibold text-primary">
							The Classical Difference
						</h2>
						<p className="mb-6">
							Unlike generic discipline tracking systems, PaideiaTrack is built
							specifically for the unique needs of classical education. We focus
							on character formation rather than mere behavior management,
							aligning with the classical tradition of nurturing wisdom and
							virtue.
						</p>

						<Card className="mt-8 bg-accent text-accent-foreground">
							<CardContent className="p-6">
								<blockquote className="text-lg italic">
									"Education is the cultivation of wisdom and virtue."
									<br />
									<span className="mt-2 block text-base">— Aristotle</span>
								</blockquote>
							</CardContent>
						</Card>

						<div className="mt-12 flex justify-center">
							<Link
								to="/login"
								className="rounded-md bg-primary px-8 py-3 font-semibold text-primary-foreground transition-colors hover:bg-primary/90"
							>
								Get Started
							</Link>
						</div>
					</div>
				</CardContent>
			</Card>

			<div className="text-center text-sm text-muted-foreground">
				<p>© {new Date().getFullYear()} PaideiaTrack. All rights reserved.</p>
			</div>
		</div>
	)
}
